import { CommentCheckIcon } from './CommentCheckIcon';

/**
 * author: Austin Andrews
 * id 5D2CEEF1-3F19-4AD2-8965-13DB365B0013
 * name comment-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-check.svg
 * tags
 */
export const CommentTickIcon = CommentCheckIcon;
export default CommentTickIcon